<div class="app-body animated fadeIn m-0">
  <div class="row justify-content-start m-0 py-3" style="width:100%;">
    <div class="col-lg-12 col-md-12 col-sm-12 login-new-details px-5">
      <div class="logo-org">
        <img src="/assets/img/brand/logo-high-original.png" style="width:180px;" />
      </div>
    </div>
  </div>
  <div class="row justify-content-start mx-0 mt-4" style="width:100%;">
    <div class="col-lg-4 col-md-6 col-sm-9 col-12 login-new-details px-5 mt-3">
      <h3 class="title">Login</h3>
      <p class="subline-text"><small>Enter your details to get sign in to your account</small></p>
      <form #loginForm="ngForm" (ngSubmit)="login()">
        <p style="color: tomato;">{{errorMsg}}</p>
        <label class="form-group has-top-label mb-4">
          <input class="form-control" type="text" name="Lid" placeholder="Login Id" [(ngModel)]="model.loginId"
            required>
          <span class="text-label">Login ID</span>
          <i class="fa fas fa-user" aria-hidden="true"></i>
          <p style="color: tomato;">{{errorEmployeeid}}</p>
        </label>

        <label class="form-group has-top-label mb-4">
          <input class="form-control" [type]="inputType" name="pw" placeholder="Password" [(ngModel)]="model.password"
            required>
          <span class="text-label">Password</span>
          <i class="fa" [ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}" aria-hidden="true"
            (click)="passwordVisibility()"></i>
          <p style="color: tomato;">{{errorPassword}}</p>
        </label>

        <div class="form-group mt-1">
          <button type="submit" class="btn py-3 btn-block login-btn">Sign in</button> <!--routerLink="/dashboard"-->
        </div>

        <!-- <div class="form-group forgot-pass" style="display: flex;text-align:center; flex-direction: column;">
          <a class="forgot" data-toggle="modal">Forgot your email or password?</a>
        </div> -->

      </form>
    </div>
  </div>

</div>



<!----Forgot Password POPUP------->
<!--[config]="{ backdrop: 'static' }"-->
<!-- <div bsModal #forgotPasswordModal="bs-modal" class="modal fade forgot-password-modal" tabindex="-1" role="dialog" [config]="{ backdrop: 'static' }" aria-labelledby="forgotPasswordModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
             <div class="title"><h4>Forgot Password</h4></div>
             <div class="row mt-5">
                  <div class="col-md-12 mb-3">
                    <div class="form-group">
                      <label>Email</label>
                      <input class="form-control form-control-lg" type="email" name="email" placeholder="Email: yourmail@mail.com"  style="font-size:1.0rem;"/>
                    </div>
                  </div>
             </div>
             <div class="row">
                   <div class="col-md-6 col-6 pr-2"><button type="button" class="btn btn-outline-primary forgot-btn btn-block" routerLink="/reset-password">Send Link</button></div>
                   <div class="col-md-6 col-6 pl-2"><button type="button" class="btn btn-outline-secondary forgot-cancel-btn btn-block" (click)="forgotPasswordModal.hide()">Close</button></div>
             </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div> -->
<!-- /.modal -->